angular
    .module('WizApp')
    .controller('HomeV4Controller', [
        '$window',
        '$scope',
        '$timeout',
        '$interval',
        'AnalyticsService',
        'ScrollerService',
        'TypingService',
        'WizDataService',
        function ($window, $scope, $timeout, $interval, AnalyticsService, ScrollerService, TypingService, WizDataService) {
            let vm = this;

            vm.dropdown = {
                header: {
                    opened: false,
                },
                landing: {
                    opened: false,
                },
            };

            vm.getCurrentLanguage = getCurrentLanguage;
            vm.responsiveMenu = {
                onToggle: {
                    open: onOpenerToggle,
                    close: onCloserToggle,
                },
                status: {
                    opener: false,
                    closer: false,
                },
                closeMenu: closeMenu,
            };
            vm.header = {
                status: {
                    open: false,
                },
            };
            vm.landing = {
                caret: {
                    onClick: landingCaretOnClick,
                }
            };

            // We let the library is default config for the cursor
            const landingTypingParameters = {
                typeSpeed: 50,
                startDelay: 0,

                fadeOut: true,
                fadeOutClass: 'typed-fade-out',
                fadeOutDelay: 200,

                loop: false,
                loopCount: 0,
                onComplete: callbackTyping

            };

            TypingService.start(
                '.home__landing__typing-target',
                '.home__landing__job-sentences',
                landingTypingParameters);

            vm.triggerEarly = triggerEarly;

            var skip = false;

            function triggerEarly() {
                callbackTyping();
                skip = true;
            }

            function callbackTyping() {
                if (skip || getCurrentLanguage() !== 'fr_FR') {
                    return;
                }
                $('.typed-cursor').first().hide();
                $('.home__landing__find-job').hide().text("Découvrir les offres pour ").fadeIn();
                $('.home__landing__typing-target').replaceWith($('.prompt-for-input').fadeIn());

                var extended =  {
                    typeSpeed: 50,
                    startDelay: 0,

                    fadeOut: true,
                    fadeOutClass: 'typed-fade-out',
                    fadeOutDelay: 200,

                    loop: false,
                    loopCount: 0,
                    attr: 'placeholder',
                    onComplete: function () {
                    }
                };

                $.fn.isInViewport = function() {
                    var elementTop = $(this).offset().top;
                    var elementBottom = elementTop + $(this).outerHeight();
                    var viewportTop = $(window).scrollTop();
                    var viewportBottom = viewportTop + $(window).height();
                    return elementBottom > viewportTop && elementTop < viewportBottom;
                };

                if ($('.transparent-input').isInViewport()){
                    $('.transparent-input').focus();
                }

                TypingService.start(
                    '.transparent-input',
                    '.home__landing__job-sentences2',
                    extended);
                setTimeout(() => {
                    $('.hvr-underline-from-left').addClass('search');
                    $('.loupe').addClass('slidein');
                }, 500);

            }

            // Header appears after the button on landing block
            angular.element($window).bind('scroll', () => {
                if (shouldShowHeader()) {
                    if (!vm.header.status.open) {
                        vm.header.status.open = true;
                        AnalyticsService.send({
                            event: 'Home',
                            category: 'Display Sticky Menu',
                            label: ''
                        });
                        $scope.$apply();
                    }
                } else {
                    vm.dropdown.header.opened = false;
                    vm.header.status.open = false;
                    $scope.$apply();
                }
            });

            /* search */
            vm.store = store;
            vm.input = '';
            function store() {
                if (this.input !== ''){
                    var search = {
                        terms: this.input
                    };
                    localStorage.setItem('search', JSON.stringify(search));
                    localStorage.setItem('referer', $window.location.origin + '/search/jobs?q=');
                    AnalyticsService.send({ category: 'Home', action: 'Fill search', label: '' });
                } else {
                    localStorage.removeItem('search');
                    localStorage.removeItem('referer');
                }
            }

            function onOpenerToggle(state) {
                vm.responsiveMenu.status.closer = state.toggled ? true : vm.responsiveMenu.status.closer;
            }

            function onCloserToggle() {
                vm.header.status.open = shouldShowHeader();
            }

            function getCurrentLanguage() {
                return WizDataService.get('locales').current;
            }

            function shouldShowHeader() {
                return ($window.pageYOffset > vm.DOMElements.landingButtonPos &&
                    ((!vm.responsiveMenu.status.closer) ||
                        vm.DOMElements.$responsiveMenu.css('display') === 'none'));
            }

            function landingCaretOnClick() {
                ScrollerService.to('.home__jobs', 70);
            }

            function closeMenu() {
                vm.responsiveMenu.status.opener = false;
                vm.responsiveMenu.status.closer = false;
            }

            // ############### définition du caroussel
            vm.caroussel = {
                action: {
                    next: null,
                    start: null,
                    click: null,
                    getData: null
                },
                data: {
                    interval: null,
                    cardWrapper: null
                }
            };

            vm.caroussel.action.start = () => {
                $timeout(() => {
                    vm.caroussel.data.cardWrapper = angular.element('.card-wrapper');
                    vm.caroussel.action.next();
                    vm.caroussel.action.next();
                    vm.caroussel.action.next();
                    vm.caroussel.data.interval = $interval(vm.caroussel.action.next, 3820);
                });
            };

            vm.caroussel.action.next = () => {
                let cardWrapper = vm.caroussel.data.cardWrapper;
                cardWrapper.find('.card.card--previous').removeClass('card--previous');
                cardWrapper.find('.card.card--active').removeClass('card--active').addClass('card--previous');
                cardWrapper.find('.card.card--next-1').removeClass('card--next-1').addClass('card--active');
                cardWrapper.find('.card.card--next-2').removeClass('card--next-2').addClass('card--next-1');

                let card = cardWrapper.find('.card.card--next-1 + .card');
                if (!card.length) {
                    card = cardWrapper.find('.card:first-child');
                }
                card.addClass('card--next-2');
            };

            vm.caroussel.action.click = () => {
                $interval.cancel(vm.caroussel.data.interval);
                vm.caroussel.action.next();
                vm.caroussel.data.interval = $interval(vm.caroussel.action.next, 3820);
            };

            vm.caroussel.action.getData = () => {
                switch (vm.getCurrentLanguage()) {
                    case 'fr_FR':
                        return [
                            {
                                title: 'Coordinateur Logistique H/F (CDI)',
                                company: { name: 'Vente privée', logo: 'logo-vente-privee.png' },
                                domain: 'LOGISTIQUE',
                                location: { display_value: 'Saint-Denis (Seine-Saint-Denis)' }
                            }, {
                                title: 'Conseiller bancaire H/F (CDI)',
                                company: { name: 'Crédit agricole', logo: 'logo-ca-centre.svg' },
                                domain: 'BANQUE / ASSURANCE',
                                location: { display_value: 'Nantes (Loire-Atlantique)' }
                            }, {
                                title: 'Business Developer H/F (Stage)',
                                company: { name: 'OVH', logo: 'logo-ovh.png' },
                                domain: 'COMMERCE / VENTE',
                                location: { display_value: 'Roubaix (Nord)' }
                            }, {
                                title: 'Data Analyst H/F (Stage)',
                                company: { name: 'Air France', logo: 'logo-air-france.svg' },
                                domain: 'SYSTEME D\'INFORMATION',
                                location: { display_value: 'Clermont-Ferrand (Puy-de-Dôme)' }
                            }, {
                                title: 'Assistant RH H/F (Alternance)',
                                company: { name: 'Accorhotels', logo: 'logo-accor-hotels.png' },
                                domain: 'RESSOURCES HUMAINES',
                                location: { display_value: 'Paris (Ile-de-France)' }
                            }, {
                                title: 'Vendeur H/F (CDD)',
                                company: { name: 'Decathlon', logo: 'logo-decathlon.svg' },
                                domain: 'COMMERCE / VENTE',
                                location: { display_value: 'Grenoble (Isère)' }
                            }, {
                                title: 'Comptable H/F (Alternance)',
                                company: { name: 'KPMG', logo: 'logo-kpmg.svg' },
                                domain: 'AUDIT / COMPTABILITE',
                                location: { display_value: 'Nimes (Gard)' }
                            }, {
                                title: 'Garde d\'enfants H/F (Job étudiant)',
                                company: { name: 'Kangourou Kids', logo: 'logo-kangourou.png' },
                                domain: 'TRAVAIL SOCIAL / ANIMATION / ENFANCE',
                                location: { display_value: 'Marseille (Bouches-du-Rhône)' }
                            }
                        ];
                    case "it_IT":
                        return [
                            {
                                title: 'Controllo di Gestione M/F (Stage / Tirocini)',
                                company: { name: 'Crédit agricole', logo: 'logo-ca-centre.svg' },
                                domain: 'BANCHE',
                                location: { display_value: 'Milano' }
                            }, {
                                title: 'Business Analyst Manager M/F (Apprendistato)',
                                company: { name: 'Accorhotels', logo: 'logo-accor-hotels.png' },
                                domain: 'ALBERGHIERO / TURISMO',
                                location: { display_value: 'Roma' }
                            }, {
                                title: 'Sport Advisor M/F (Tempo determinato)',
                                company: { name: 'Decathlon', logo: 'logo-decathlon.svg' },
                                domain: 'SPORT',
                                location: { display_value: 'Udine' }
                            }, {
                                title: 'Tecnico Elettronico di Produzione (Tempo indeterminato)',
                                company: { name: 'Thales', logo: 'logo-thales.svg' },
                                domain: 'SISTEMI INFORMATICI',
                                location: { display_value: 'Gorgonzola' }
                            }, {
                                title: 'Solution Architect M/F (Tempo indeterminato)',
                                company: { name: 'Atos', logo: 'logo-atos.svg' },
                                domain: 'SISTEMI / NETWORKS / TELECOMUNICAZIONO',
                                location: { display_value: 'Milano' }
                            }, {
                                title: 'Stage HR & Legal (Stage / Tirocini)',
                                company: { name: 'LVMH', logo: 'logo-lvmh.svg' },
                                domain: 'RISORSE UMANE',
                                location: { display_value: 'Roma' }
                            }, {
                                title: 'Application Developer - Software (Tempo indeterminato)',
                                company: { name: 'Schneider Electric', logo: 'logo-schneider-electric.svg' },
                                domain: 'SISTEMI INFORMATICI',
                                location: { display_value: 'Stezzano' }
                            }
                        ];
                    default:
                        return [
                            {
                                title: 'Night receptionist M/F (Entry-level job)',
                                company: { name: 'Accorhotels', logo: 'logo-accor-hotels.png' },
                                domain: 'RECEPTION / ADMINISTRATION',
                                location: { display_value: '' }
                            }, {
                                title: 'Support Engineer / Sonar M/F (Internship)',
                                company: { name: 'Thales', logo: 'logo-thales.svg' },
                                domain: 'SYSTEM / NETWORKS / TELECOM',
                                location: { display_value: '' }
                            }, {
                                title: 'Customer advisor / Ski M/F (Part-time job)',
                                company: { name: 'Decathlon', logo: 'logo-decathlon.svg' },
                                domain: 'SALES / BUSINESS',
                                location: { display_value: '' }
                            }, {
                                title: 'Finance analyst M/F (Full-time job)',
                                company: { name: 'Nestlé', logo: 'logo-nestle.svg' },
                                domain: 'FINANCE / MANAGEMENT',
                                location: { display_value: '' }
                            }, {
                                title: 'Warehousing Coordinator M/F (Full-time job)',
                                company: { name: 'Unilever', logo: 'logo-unilever.svg' },
                                domain: 'LOGISTICS',
                                location: { display_value: '' }
                            }
                        ];
                }
            };

            // ############### fin de la définition du caroussel
            // #################################################


            (function (topPosition) {
                vm.DOMElements = {
                    $header: $('.home__header'),
                    $responsiveMenu: $('.home__responsive-menu'),
                    $home: $('.home'),
                    landingButtonPos: $('.home__landing__button').offset().top,
                };

                vm.responsiveMenu.status.open = false;

                $timeout(() => {
                    vm.header.status.open = topPosition > vm.DOMElements.landingButtonPos;
                });

                vm.caroussel.data.items = vm.caroussel.action.getData();

                vm.languages = [
                    {
                        lang: 'fr_FR',
                        label: 'FR - Français',
                        link: 'https://www.wizbii.com/'
                    }, {
                        lang: 'en_GB',
                        label: 'EN - English',
                        link: 'https://.wizbii.com/'
                    }, {
                        lang: 'it_IT',
                        label: 'IT - Italian',
                        link: 'https://.wizbii.com/'
                    }, {
                        lang: 'de_DE',
                        label: 'DE - Deutsch',
                        link: 'https://.wizbii.com/'
                    }, {
                        lang: 'es_ES',
                        label: 'ES - Spanish',
                        link: 'https://.wizbii.com/'
                    }
                ];
                vm.caroussel.action.start();
            })($window.pageYOffset);

            return vm;
        }
    ])
;
